export const EnLocale = {
    page: {
        txtTitle: 'SHIRITORI | Online Japanese vocabulary made easy with the fun game しらとり',
    },
    common: {
        txtLogoAlt: 'Shiritori train',
    },
    header: {
        txtLeave: 'LEAVE GAME',
    },
    dialog: {
        leave: {
            txtTitle: 'Leave this game?',
            btnStay: 'STAY IN GAME',
            btnLeave: 'LEAVE AND FORFEIT',
        },
    },
    home: {
        btnNewGame: 'NEW GAME',
        btnMainMenu: 'MAIN MENU',
        btnJoinGame: 'JOIN',
        btnReturnToGame: 'RETURN TO GAME',
    },
    create: {
        headingNamePrompt: 'What will we call you?',
        placeholderName: 'Your name',
        btnOk: 'OK',
    },
    join: {
        placeholderName: 'Your name',
        placeholderGameId: 'game id',
        btnJoinGame: 'JOIN',
    },
    configure: {
        header: 'GAME SETUP',
        labelExpectedPlayers: 'Number of players',
        labelBoardSize: 'Board size',
        labelWordList: 'Word list',
        labelAllowHints: 'Allow hints',
        labelTurnTimer: 'Turn timer',
        optionNoTimer: 'No Timer',
        optionTimer: 'Timer',
        unitSeconds: 'sec',
        btnStartGame: 'START',
        toastCreateError: 'Error: Cannot create this game',
        toastTryAgain: 'Error: Please try again later.',
    },
    game: {
        lobby: {
            btnReady: 'Ready',
            txtShareInvite: 'Share this code with your friends!',
            txtPlayer: 'Player',
            txtTeam: 'Team',
        },
        message: {
            noSuchGame: 'This game does not exist',
            txtLoading: 'Loading...',
            txtCannotJoin: 'Cannot join game',
        },
        gameplay: {
            board: {
                timeoutTitle: 'TIME',
                timeoutSubtitle: 'out',
            },
            wordSearch: {
                multipleMatches: 'MULTIPLE MATCHES FOUND!',
                yourTurn: 'YOUR TURN',
                placeholder: 'What should we play?',
                playAction: 'PLAY',
                timerSeconds: '{{seconds}}s',
                toastNoSuchWord: 'No such word!',
                toastCantPlay: "Can't play that word!",
                toastPlayed: 'Played "{{word}}"',
                toastPlayFailed: "Whoops, couldn't play that word!",
                validation: {
                    syllableMismatch: 'Starting syllable does not match',
                    missingLastWord: 'Last turn has no word',
                    wordNotInList: 'Word does not belong to list',
                }
            },
            spectate: {
                waitingOn: 'WAITING ON {{player}}',
                timeLeft: 'Time left: {{seconds}}s',
            },
            endGame: {
                header: 'GAME ENDED',
                viewResults: 'VIEW RESULTS',
                statsTotalTime: 'Total game time',
                statsSquaresFilled: 'Squares filled',
                statsLongestWord: 'Longest word',
                share: 'SHARE',
                sharing: 'Sharing...',
                ariaCloseLabel: 'Close game over modal',
            }
        },
    },
    footer: {
        linkHowToPlay: 'How to Play',
        linkPrivacyPolicy: 'Privacy Policy',
        txtAllRightsReserved: 'All Rights Reserved.',
    },
    howToPlay: {
        title: 'How to Play Shiritori しりとり (shiritori)',
        btnPlayNow: 'Play Now!',
        btnReturnToGame: 'Return to game:',
        description1: 'b|Shiritori| is our online, multiplayer spin on the Japanese word-chain game しりとり. Build a picture board while practicing vocabulary with friends or solo.',
        description2: 'Create or join a game, pick your board size, picture set, and word list, then race to fill the grid with valid words before anyone slips up.',
        gameSetup: {
            title: 'Create or Join a Game',
            p1: 'Start singleplayer or invite up to 9 friends (10 players total) with a shareable link or game code.',
            p2: 'Choose the options you want: board size (3x3, 5x5, 7x7), background pattern/color, picture set, and the word list to study.',
            p3: 'Friends open the link, pick a nickname, and appear in the lobby; the game begins when the expected players have joined.',
            p4: 'Late arrivals can still watch an ongoing match in a view-only mode.',
        },
        objective: {
            title: 'Objective',
            p1: 'Chain words so each new word begins with the last syllable of the previous one, fill the board, and never end a word with ん.',
        },
        wordRules: {
            title: 'Valid Words',
            p1: 'Type in kana or romaji; romaji is converted to hiragana client-side before checking.',
            p2: 'Words must exist in the selected list (100/1000 common, foods, sports, etc.) and show their meaning after you play them.',
            p3: 'Used words are blocked. If homophones are allowed, you can pick an unused variation with the right picture.',
            li1: 'Starts with the required syllable from the previous turn',
            li2: 'Does not end with ん (n)',
            li3: 'Is included in the chosen word list',
            li4: 'Has not been played earlier in this game',
            li5: 'Uses an allowed homophone/picture when that rule is enabled',
            p4: 'Every valid play drops its picture into the board in order, filling the grid left to right, top to bottom. e|Example:_そば_→_バス|',
        },
        turnFlow: {
            title: 'Turns & Timing',
            p1: 'Turns rotate through the player list; when you become active you get up to 10 seconds from when you see your turn.',
            p2: 'Shiritori waits until the next player is active (browser focused) before starting their countdown, preventing restarts or reloads from skipping the timer.',
            p3: 'Enter your word, watch live validation, and submit before the deadline - invalid or late submissions end the match immediately.',
        },
        boardFlow: {
            title: 'Board, Flow, and Ending',
            p1: 'The board shows each played word with its picture, player name, and turn number, with arrows tracing the order across the grid.',
            p2: 'When it is someone else\'s turn, you can still see the required starting syllable and the countdown while you wait.',
            p3: 'If all spaces are filled with valid words, the game ends in success and shows the completed board to share.',
            p4: 'If no valid move is submitted before the timer expires, the game ends with a summary of who timed out or played an invalid word.',
        },
        summary: {
            title: 'Summary',
            p1: 'Shiritori keeps shiritori fast and visual - quick rounds, clear rules, and picture mnemonics help everyone keep the chain alive.',
            p2: 'Share a link, fill the board, and see how long your word chain can run.',
        }
    },
    bugsAndFeatures: {
        title: 'Bug reports and new Features',
        p1: 'We built this game as a different way to play the classic game of k|しりとり.| As a team who loves games, we are always looking for ways to improve the game and make it more enjoyable for players.',
        cta: {
            l1: 'In fact, we would love it if you could help us by ',
            a: 'sharing our game with your friends',
            l2: ' on social media!'
        },
        p2: 'Should you encounter any bugs or have any suggestions for new features, please let us know!',
        bugs: {
            title: 'Bugs',
            p1: 'Please report any strange behavior, errors, or bugs to us directly on our public a|https://github.com/indexinteractive/|GitHub_repository| .  Be sure to include as much detail as possible, including the steps to reproduce the bug.'
        },
        features: {
            title: 'New Features',
            p1: 'If you have any suggestions for new features, improvements, or ideas for the game, please let us know by creating a new discussion over at our a|https://github.com/indexinteractive/|GitHub_Discussions|  page.'
        }
    },
    share: {
        title: 'Shiritori | Online Japanese vocabulary made easy with the fun game しらとり - SHIRITORI',
        text: 'Play Shiritori online with your friends or random players. No sign-up required!',
    }
};
